import ServicePageLayout from "@/pages/services/components/ServicePageLayout";

const relatedServices = [
  { label: "Membranes bitumineuses", href: "/services/membranes-bitumineuses" },
  { label: "Étanchéité liquide", href: "/services/etancheite-liquide" },
  { label: "Réfection étanchéité", href: "/services/refection-etancheite" },
  { label: "Toitures-terrasses", href: "/services/toitures-terrasses" },
  { label: "Étanchéité + isolation thermique", href: "/services/etancheite-isolation" },
];

export default function GeomembranesEPDMPage() {
  return (
    <ServicePageLayout
      tag="Haute durabilité"
      title="Géomembranes EPDM"
      subtitle="Membranes synthétiques EPDM pour toitures végétalisées, bassins, réservoirs et ouvrages hydrauliques nécessitant une longévité maximale."
      heroImage="https://readdy.ai/api/search-image?query=professional%20installation%20of%20black%20EPDM%20rubber%20geomembrane%20on%20large%20flat%20rooftop%2C%20workers%20unrolling%20and%20laying%20synthetic%20rubber%20sheet%2C%20wide%20seamless%20black%20surface%2C%20modern%20commercial%20building%2C%20professional%20waterproofing%20photography%2C%20bright%20daylight&width=1440&height=900&seq=ksbtp-epdm-hero-001&orientation=landscape"
      heroAlt="Pose de géomembranes EPDM KS BTP"
      intro="L'EPDM (Éthylène Propylène Diène Monomère) est une membrane synthétique en caoutchouc vulcanisé offrant une durée de vie exceptionnelle — jusqu'à 50 ans — et une résistance remarquable aux UV, à l'ozone et aux variations thermiques extrêmes. KS BTP pose des géomembranes EPDM sur toitures-terrasses végétalisées, bassins de rétention, réservoirs, ouvrages hydrauliques et toitures à faible pente. La membrane est disponible en grandes largeurs, réduisant le nombre de joints et donc les risques de fuite. Chaque pose est réalisée par nos techniciens certifiés, avec soudure à froid des recouvrements."
      techItems={[
        { icon: "ri-leaf-line", label: "Toitures végétalisées" },
        { icon: "ri-water-flash-line", label: "Bassins & réservoirs" },
        { icon: "ri-sun-line", label: "Résistance UV & ozone" },
        { icon: "ri-temp-cold-line", label: "Tenue aux grands écarts thermiques" },
        { icon: "ri-expand-width-line", label: "Grandes largeurs sans joint" },
        { icon: "ri-recycle-line", label: "Matériau recyclable & durable" },
      ]}
      steps={[
        {
          number: "01",
          title: "Étude & dimensionnement",
          description: "Calcul des surfaces, définition des largeurs de lés, identification des points singuliers et choix de l'épaisseur adaptée à l'usage.",
        },
        {
          number: "02",
          title: "Préparation du support",
          description: "Mise en place du complexe isolant ou du géotextile de protection selon le type d'ouvrage. Vérification de la planéité et de la propreté.",
        },
        {
          number: "03",
          title: "Pose de la membrane",
          description: "Déroulage des lés EPDM, assemblage par soudure à froid (colle néoprène ou ruban adhésif double face), traitement des relevés et pénétrations.",
        },
        {
          number: "04",
          title: "Contrôle & finitions",
          description: "Vérification de l'étanchéité de tous les joints, mise en place des protections mécaniques ou du substrat végétalisé, réception du chantier.",
        },
      ]}
      advantages={[
        "Durée de vie exceptionnelle : jusqu'à 50 ans sans dégradation significative",
        "Résistance aux UV, à l'ozone et aux températures de -40°C à +120°C",
        "Grandes largeurs disponibles (jusqu'à 15 m) réduisant le nombre de joints",
        "Légèreté de la membrane : faible charge sur la structure porteuse",
        "Compatibilité avec les toitures végétalisées, bassins et ouvrages hydrauliques",
        "Matériau recyclable, faible empreinte carbone sur le cycle de vie",
        "Garantie décennale et certification ATEC pour les systèmes posés",
      ]}
      galleryImages={[
        {
          src: "https://readdy.ai/api/search-image?query=workers%20installing%20black%20EPDM%20rubber%20membrane%20on%20flat%20rooftop%2C%20unrolling%20large%20sheet%20of%20synthetic%20rubber%20waterproofing%2C%20professional%20installation%20team%2C%20construction%20site%2C%20wide%20angle%20photography&width=600&height=440&seq=ksbtp-epdm-gal-001&orientation=landscape",
          alt: "Déroulage membrane EPDM sur toiture",
        },
        {
          src: "https://readdy.ai/api/search-image?query=green%20rooftop%20garden%20with%20EPDM%20waterproofing%20base%20visible%20at%20edges%2C%20lush%20vegetation%20on%20modern%20urban%20building%2C%20professional%20landscaping%20on%20rooftop%2C%20Paris%20architecture%2C%20aerial%20view&width=600&height=440&seq=ksbtp-epdm-gal-002&orientation=landscape",
          alt: "Toiture végétalisée sur membrane EPDM",
        },
        {
          src: "https://readdy.ai/api/search-image?query=EPDM%20geomembrane%20lining%20in%20water%20retention%20basin%2C%20black%20rubber%20membrane%20covering%20concrete%20basin%20walls%20and%20floor%2C%20hydraulic%20engineering%20project%2C%20professional%20waterproofing%20photography&width=600&height=440&seq=ksbtp-epdm-gal-003&orientation=landscape",
          alt: "Géomembrane EPDM en bassin de rétention",
        },
      ]}
      relatedServices={relatedServices}
    />
  );
}
